import { Box } from '@mui/material';
import styled from 'styled-components';

import { Button } from '@/shared/components/ui/button/button';

export const StyledButton = styled(Button)`
  && {
    height: 3.25rem;
    width: 260px;
    padding: 0.25rem 1rem 0.25rem 0.25rem;
    justify-content: flex-start;

    &:hover {
      background-color: ${({ theme }) => theme.palette.background.paper};
      box-shadow: 0 0 0 2px ${({ theme }) => theme.palette.stroke.secondary};
    }
  }
`;

export const StyledAvatar = styled(Box)`
  && {
    width: 2.75rem;
    min-width: 2.75rem;
    height: 2.75rem;
    background-color: ${({ theme }) => theme.palette.primary.light};
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ theme }) => theme.typography.p2};
    color: ${({ theme }) => theme.palette.text.primary};
    border-radius: ${({ theme }) => theme.shape.avatarRadius};
    transition: background-color 0.2s ease-in-out;
  }
`;
